declare const realtimeEventData: unique symbol;

/** A typed event name. Definitions are independent from the channel carrying the event. */
export type RealtimeEventDefinition<T> = Readonly<{
  name: string;
  [realtimeEventData]?: T;
}>;

/** Define the payload type associated with one wire event name. */
export function defineRealtimeEvent<T>(name: string): RealtimeEventDefinition<T> {
  return Object.freeze({ name });
}

export type RealtimeEvent<T> = {
  data: T;
  revision?: number;
  originConnectionId?: string;
};
